import React, { useEffect, useMemo, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import Footer from "../../Footer";
import _ from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { Contacts } from "@capacitor-community/contacts";
import {
  hide_loader,
  set_reciver_details,
  show_loader,
} from "../../actions/app";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getCurrentLocation } from "../../resources/get_current_location";
import { useTranslation } from "react-i18next";
import api_requests from "../../resources/api_requests";

const SetDeliveryAddress = () => {
  const [searchParams] = useSearchParams();
  const search_from = searchParams.get("from");
  const select_is_saved = searchParams.get("is_saved");

  const dispacth = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { reciver_details, sender_details } = useSelector(
    (state) => state.app,
    shallowEqual
  );
  const [current_address, set_current_address] = useState();
  const [is_error, set_is_error] = useState(false);
  const [number_error, set_number_error] = useState(false);

  const [formData, setFormData] = useState({
    pickupAddress: "",
    senderName: "",
    senderNumber: "",
    saveAddress: "",
  });

  const handle_go_back = () => {
    navigate(-1);
    if (btn_disable) {
      dispacth(set_reciver_details({}));
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getCurrentLocation();
        set_current_address(response);
      } catch (error) {
        set_is_error(true);
      }
    }
    if (_.isEmpty(reciver_details)) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(reciver_details)) {
      set_current_address(reciver_details);
      if (reciver_details?.name) {
        setFormData({
          pickupAddress: reciver_details?.address_line1,
          senderName: reciver_details?.name,
          senderNumber: reciver_details?.mobile,
          saveAddress: reciver_details?.label,
        });
      }
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "senderNumber") {
      set_number_error(false);
    }
    if (name == "senderNumber" && value.length > 10) return;
    if (name == "saveAddress" && value.length > 10) return;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const _addrees = !_.isEmpty(reciver_details)
      ? _.cloneDeep(reciver_details)
      : _.cloneDeep(current_address);
    const { label, address_name, name, mobile, id, ...filteredAddress } = _addrees;

    const data = {
      ...filteredAddress,
      address_line1: formData.pickupAddress,
      ...(!_.isEmpty(label) && { label }),
      is_saved: !_.isEmpty(formData.saveAddress),
    };
    if (select_is_saved == "false" || select_is_saved == null) {
      try {
        dispacth(show_loader());
        const res = await api_requests.create_address(data);
        const newData = {
          ...data,
          name: formData.senderName,
          mobile: formData.senderNumber,
          id: res?.data?.address_id,
          address_name:
            reciver_details?.address_name || current_address?.address_name,
        };
        dispacth(set_reciver_details(newData));
        dispacth(hide_loader());
        navigate("/cart");
      } catch (error) {
        dispacth(hide_loader());
      }
    } else {
      const newData = {
        ...reciver_details,
        name: formData.senderName,
        mobile: formData.senderNumber,
      };
      dispacth(set_reciver_details(newData));
    }
    navigate("/cart");
  };

  const open_contacts = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        const permission = await Contacts.requestPermissions();
        console.log("permission", permission);
        if (
          permission?.contacts !== "granted" &&
          permission?.contacts !== "limited"
        ) {
          alert(t("contacts_permission_not_granted"));
          return;
        }

        const result = await Contacts.pickContact({
          projection: { name: true, phones: true },
        });
        console.log("result", result);
        const displayName = result?.contact?.name?.display || "";
        const rawNumber = result?.contact?.phones?.[0]?.number || "";
        const digitsOnly = rawNumber.replace(/\D/g, "");
        const normalizedNumber =
          digitsOnly.length > 10 ? digitsOnly.slice(-10) : digitsOnly;

        setFormData((prevData) => ({
          ...prevData,
          senderName: displayName || prevData.senderName,
          senderNumber: normalizedNumber || prevData.senderNumber,
        }));
        set_number_error(false);
        return;
      }

      if ("contacts" in navigator && "select" in navigator.contacts) {
        const properties = ["name", "email", "tel"];
        const options = { multiple: false };
        const contacts = await navigator.contacts.select(properties, options);
        const contact = contacts?.[0];
        const displayName = contact?.name?.[0] || "";
        const rawNumber = contact?.tel?.[0] || "";
        const digitsOnly = rawNumber.replace(/\D/g, "");
        const normalizedNumber =
          digitsOnly.length > 10 ? digitsOnly.slice(-10) : digitsOnly;
        setFormData((prevData) => ({
          ...prevData,
          senderName: displayName || prevData.senderName,
          senderNumber: normalizedNumber || prevData.senderNumber,
        }));
        set_number_error(false);
      } else {
        alert(t("contacts_not_supported"));
      }
    } catch (error) {
      console.error("Error accessing contacts:", error);
    }
  };

  const btn_disable = useMemo(() => {
    let value = true;
    if (
      formData.pickupAddress != "" &&
      formData.senderName != "" &&
      formData.senderNumber != "" &&
      formData.senderNumber.length == 10 &&
      !_.isEmpty(current_address)
    ) {
      value = false;
    }
    return value;
  }, [formData]);
  return (
    <div className="relative min-h-screen bg-gray-50 flex mt-6 flex-col">
      <div
        className="overflow-auto"
        style={{ height: `calc(100vh - 83px - env(safe-area-inset-bottom))` }}
      >
        <div
          className="flex items-center gap-2 pl-6 pb-6"
          onClick={handle_go_back}
        >
          <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" />
          <p className="font-custom text-sm font-semibold text-dark_black">
            {t("delivery_address")}
          </p>
        </div>

        <div className="relative bg-[#7953d2]/20 py-4 px-12 flex justify-between items-center">
          {_.isEmpty(current_address) ? (
            <p className="font-custom text-sm text-dark_black font-bold">
              {is_error
                ? t("select_your_location")
                : t("fetching_location")}
            </p>
          ) : (
            <div>
              <p className="font-custom text-sm text-dark_black font-bold line-clamp-2 pr-6">
                {current_address?.address_name}
              </p>
              <p className="font-custom text-dark_gray text-[10px] font-medium line-clamp-2">
                {current_address?.formatted_address}
              </p>
            </div>
          )}
          {
            is_error ? (
              <div className="font-custom self-start absolute top-[8px] right-[14px]">
                <button
                  onClick={() =>
                    navigate(`/search-location?type=delivery&from=${search_from}`)
                  }
                  className="text-secondary text-[10px] font-medium border border-secondary py-[2px] px-[9px] rounded-full bg-white">{t("add")}</button>
              </div>
            ) : (
              <img src={ImageLinks.edit_purple} alt="edit" className="self-start absolute top-[8px] right-[14px]" onClick={() => navigate(`/search-location?type=delivery&from=${search_from}`)} />
            )
          }
        </div>
        <form onSubmit={handleSubmit} className="pl-12 pr-12 pt-6 space-y-4">
          <div className="form-control">
            <label
              htmlFor="pickupAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary "
            >
              {t("delivery_address_label")}
            </label>
            <textarea
              id="pickupAddress"
              name="pickupAddress"
              rows="4"
              value={formData.pickupAddress}
              onChange={handleInputChange}
              className="font-custom  p-2.5 w-full text-sm text-dark_black bg-white rounded-lg border border-accents focus:outline-accents "
              placeholder={t("enter_full_address")}
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="form-control">
              <label
                htmlFor="senderName"
                className="font-custom label-text font-semibold text-secondary"
              >
                {t("receiver_name_label")}
              </label>
              <input
                type="text"
                id="senderName"
                name="senderName"
                value={formData.senderName}
                onChange={handleInputChange}
                className="font-custom block py-0.5 pe-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-accents appearance-none   focus:outline-none focus:ring-0 focus:border-accents peer"
                placeholder={t("enter_name")}
              />
            </div>
            <div className="form-control">
              <label
                htmlFor="senderNumber"
                className={`font-custom label-text font-semibold text-secondary`}
              >
                {t("receiver_number_label")}
              </label>
              <div className="flex gap-1">
                <input
                  type="number"
                  id="senderNumber"
                  name="senderNumber"
                  value={formData.senderNumber}
                  onChange={handleInputChange}
                  className="font-custom block py-0.5 pe-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-[1px] border-accents appearance-none  dark:border-accents-600 dark:focus:border-accents focus:outline-none focus:ring-0 focus:border-accents peer"
                  placeholder={t("enter_number")}
                  onBlur={() => {
                    if (formData.senderNumber.length < 10) {
                      set_number_error(true);
                    }
                  }}
                />
                <button type="button" onClick={open_contacts}>
                  <img src={ImageLinks.phone_contact} alt="Phone icon" />
                </button>
              </div>
            </div>
          </div>
          {number_error && (
            <p
              className="font-custom font-medium	text-[10px] text-error"
              style={{ marginTop: 2 }}
            >
              {t("invalid_contact_number")}
            </p>
          )}
          <div className="form-control pt-2">
            <label
              htmlFor="saveAddress"
              className="font-custom block mb-2 text-sm font-semibold text-secondary "
            >
              {t("save_address_label")}
            </label>
            <input
              type="text"
              id="saveAddress"
              name="saveAddress"
              value={formData.saveAddress}
              onChange={handleInputChange}
              className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
              placeholder={t("address_placeholder")}
            />
          </div>

          <div className="form-control" style={{ marginTop: "40px" }}>
            <button
              type="submit"
              className={`font-custom w-full py-3 rounded-[30px] text-base font-semibold
                ${btn_disable
                  ? "bg-gray text-gray-200 cursor-not-allowed"
                  : "bg-[#492897] text-white"}`
              }
              disabled={btn_disable}
            >
              {t("add_delivery_address")}
            </button>
          </div>
        </form>
      </div>
      <Footer bottom={0} />
    </div>
  );
};

export default SetDeliveryAddress;
